import React from "react";
import { Phone, Mail, Instagram, MessageCircle, MapPin } from "lucide-react";
import BotanicalBackdrop, { LeafGlyph } from "@/components/BotanicalBackdrop";
import { useEnquiry } from "@/App";
import usePageTitle from "@/hooks/usePageTitle";

const ContactPage = () => {
  usePageTitle("Contact Us");
  const enq = useEnquiry();
  return (
    <>
      <section className="relative pt-16 pb-12 lg:pt-24 lg:pb-16 overflow-hidden">
        <BotanicalBackdrop variant="corners" />
        <div className="mx-auto max-w-4xl px-6 lg:px-10 text-center">
          <div className="label-eyebrow">Contact</div>
          <h1 className="serif mt-4 text-[42px] sm:text-[54px] lg:text-[60px] leading-[1.05] text-[var(--hk-ink)]" data-testid="contact-page-title">
            We'd love to <span className="italic-accent text-[var(--hk-orange-deep)]">hear from you.</span>
          </h1>
          <p className="mt-6 max-w-2xl mx-auto text-[15.5px] leading-[1.85] text-[var(--hk-ink-2)]">
            For product enquiries, bulk orders, corporate wellness partnerships or a considered question — reach out through any of the channels below.
          </p>
        </div>
      </section>

      <section className="relative py-16">
        <div className="mx-auto max-w-6xl px-6 lg:px-10 grid md:grid-cols-2 gap-8">
          {[
            { icon: MessageCircle, label: "WhatsApp", value: "+91 72497 97972", href: "https://wa.me/917249797972", tid: "contact-whatsapp" },
            { icon: Phone, label: "Phone", value: "+91 72497 97972", href: "tel:+917249797972", tid: "contact-phone" },
            { icon: Mail, label: "Email", value: "herbkranti@gmail.com", href: "mailto:herbkranti@gmail.com", tid: "contact-email" },
            { icon: Instagram, label: "Instagram", value: "@herbkranti", href: "https://instagram.com/herbkranti", tid: "contact-instagram" },
          ].map(({ icon: Icon, label, value, href, tid }) => (
            <a key={label} href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className="hk-card p-8 flex items-start gap-5 group" data-testid={tid}>
              <div className="w-12 h-12 rounded-full flex items-center justify-center bg-[var(--hk-warm-ivory)] border border-[var(--hk-border)] text-[var(--hk-orange-deep)] group-hover:bg-[var(--hk-orange)] group-hover:text-white transition-colors">
                <Icon size={20} strokeWidth={1.5} />
              </div>
              <div>
                <div className="label-eyebrow">{label}</div>
                <div className="serif mt-1.5 text-[22px] text-[var(--hk-ink)] leading-tight">{value}</div>
              </div>
            </a>
          ))}
        </div>
      </section>

      <section className="relative py-16 bg-[var(--hk-warm-ivory)]">
        <div className="mx-auto max-w-3xl px-6 lg:px-10 text-center">
          <LeafGlyph className="mx-auto text-[var(--hk-gold-deep)] w-6 h-6" />
          <h2 className="serif mt-4 text-[28px] sm:text-[36px] text-[var(--hk-ink)] leading-tight">Enquire about a product</h2>
          <p className="mt-4 text-[15px] leading-[1.85] text-[var(--hk-ink-2)]">
            Share your details and our team will reach out with pricing, availability and delivery information.
          </p>
          <button className="hk-btn-primary mt-8" onClick={() => enq && enq.openEnquiry()} data-testid="contact-enquire-btn">
            Place an Enquiry
          </button>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
